import { IState, State } from 'country-state-city';
import * as z from 'zod';

function getStatesByCountry(
  country: string
): { code: string; displayedName: string }[] {
  if (!country) return [];

  return State.getStatesOfCountry(country).map((eachState: IState) => ({
    code: eachState.isoCode,
    displayedName: eachState.name,
  }));
}

export const addressSchema = z
  .object({
    country: z.string().min(1, 'Country is required.'),
    addressLine1: z.string().trim().min(1, 'Address line 1 is required.'),
    addressLine2: z.string().trim().optional().nullable(),
    addressLine3: z.string().trim().optional().nullable(),
    state: z.string().trim().nullable().optional(),
    city: z.string().trim().min(1, 'City is required.'),
    postalCode: z.string().trim().min(1, { message: 'Zip code is required.' }),
  })
  .superRefine((data, ctx) => {
    const availableStates = getStatesByCountry(data.country);

    if (availableStates.length === 0) {
      return;
    }

    if (!data.state) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'State is required.',
        path: ['state'],
      });
    }
  });

export type AddressSchemaFields = z.infer<typeof addressSchema>;

export const defaultAddressSchema = {
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  state: '',
  country: '',
};
